import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    getCenterSessionCommissionTables,
    getCoachSessionCommissionTable,
    putCenterSessionCommissionTables,
} from './api';
import { centerSessionCommissionTableKeys } from './keys';
import { PutCenterSessionCommissionTablesBody } from './types';

export const useCenterSessionCommissionTables = ({
    centerId,
    year,
    month,
    enabled = true,
}: {
    centerId: string;
    year: string;
    month: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: centerSessionCommissionTableKeys.list(centerId, year, month),
        queryFn: () => getCenterSessionCommissionTables({ centerId, year, month }),
        enabled: enabled && !!centerId,
        select: (data) => data?.data,
    });

export const useCoachSessionCommissionTable = ({
    centerId,
    coachId,
    year,
    month,
    enabled = true,
}: {
    centerId: string;
    coachId: string;
    year: string;
    month: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: centerSessionCommissionTableKeys.coach(centerId, coachId, year, month),
        queryFn: () => getCoachSessionCommissionTable({ centerId, coachId, year, month }),
        enabled: enabled && !!centerId && !!coachId,
        select: (data) => data?.data,
    });

export const usePutCenterSessionCommissionTables = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            centerId,
            body,
        }: {
            centerId: string;
            body: PutCenterSessionCommissionTablesBody;
        }) => putCenterSessionCommissionTables({ centerId, body }),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: centerSessionCommissionTableKeys.list(
                    variables.centerId,
                    variables.body.year,
                    variables.body.month,
                ),
            });
            // 세션 수수료 등급 변경은 급여계산·수업료 정산 결과를 바꾸므로 함께 무효화
            queryClient.invalidateQueries({ queryKey: ['getSalaryCalcsQuery'] });
            queryClient.invalidateQueries({ queryKey: ['getClassFeeSettlementForMembershipQuery'] });
        },
    });
};
